
import appStoreIcon from "./assets/appstore.png";
import playStoreIcon from "./assets/playstore.png";

const AppStoreButton = ({ platform }) => {
  const isApple = platform === "Apple";
  const imgSrc = isApple ? appStoreIcon : playStoreIcon;
  const altText = isApple
    ? "Download on the Apple App Store"
    : "Get it on Google Play";
  const href = isApple
    ? "https://apple.com/app-store"
    : "https://play.google.com"; // Placeholder links

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center"
    >
      <img src={imgSrc} alt={altText} className="h-10 w-auto" />
    </a>
  );
};

export default AppStoreButton;
